import * as React from 'react'
import { Outlet, createRootRoute } from '@tanstack/react-router'
import { Toaster } from 'sonner'

export const Route = createRootRoute({
  component: RootComponent,
})

function RootComponent() {
  return (
    <React.Fragment>
      <Outlet />
      <Toaster
        position="top-center"
        expand={true}
        richColors
        closeButton
        toastOptions={{
          duration: 5000,
          className: 'font-sans',
          style: {
            padding: '16px 20px',
            borderRadius: '12px',
            fontSize: '14px',
            fontWeight: '500',
            minWidth: '300px',
            maxWidth: '500px',
          },
        }}
      />
    </React.Fragment>
  )
}
